import React from 'react';
import { Button } from './ui/Button';
interface CTASectionProps {
  variant?: 'mid' | 'bottom';
}
export function CTASection({
  variant = 'mid'
}: CTASectionProps) {
  if (variant === 'mid') {
    return <section className="py-20 bg-red-600 text-white text-center px-4" data-id="element-1">
        <div className="max-w-4xl mx-auto" data-id="element-2">
          <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-3">
            Ready to Get Started?
          </h2>
          <p className="text-xl md:text-2xl text-red-100 mb-8 font-medium" data-id="element-4">
            No contracts. No pressure. Just results.
          </p>
          <Button size="xl" className="bg-white text-red-600 hover:bg-gray-100 hover:text-red-700 shadow-xl border-none" data-id="element-5">
            Book Your Free Class
          </Button>
          <p className="mt-4 text-sm text-red-200 opacity-80" data-id="element-6">
            Offer valid for new students only.
          </p>
        </div>
      </section>;
  }
  return <section className="py-24 bg-white text-center px-4" data-id="element-7">
      <div className="max-w-3xl mx-auto" data-id="element-8">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-9">
          Give Your Child the Gift of Confidence
        </h2>
        <p className="text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-10">
          Join hundreds of families who've seen their children transform through
          martial arts. The journey of a thousand miles begins with a single
          step.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-11">
          <Button size="xl" className="w-full sm:w-auto px-12" data-id="element-12">
            Book A Free Class Today
          </Button>
          <a href="tel:555-928-7661" className="text-gray-900 font-bold hover:text-red-600 transition-colors px-6 py-3" data-id="element-13">
            Or call (555) WATSON-1
          </a>
        </div>
      </div>
    </section>;
}